import React from 'react';

import {FIND_ALL_ESPECIALIDADES as query} from '../../../graphql/queries';
import {SelectBase} from './select-apollo';

const getVariables = ({pageNumber, search = '', pageSize = 20}) => {
  return {
    pageable: {pageNumber, pageSize, sortField: 'descricao', sortDir: 'ASC'},
    searchDTO: {search},
  };
};

export const SelectEspecialidades = (props) => {
  return (
    <SelectBase
      responseObjectName="especialidades"
      labelProp="descricao"
      query={query}
      getVariables={getVariables}
      {...props}
    />
  );
};
